import { FraudDecision, FraudStatus } from '@/types/Activity'

export const toFraudStatusColour: Record<FraudStatus, string> = {
  [FraudStatus.awaitingFraudTeamReview]: '#aba398',
  [FraudStatus.potential]: '#ed941e',
  [FraudStatus.confirmed]: 'red',
  [FraudStatus.notFraudulent]: 'inherit',
}

export const toFraudDecisionColour: Record<FraudDecision, string> = {
  [FraudDecision.confirmedFraud]: 'red',
  [FraudDecision.suspectedFraud]: 'red',
  [FraudDecision.internalRiskHighRisk]: 'red',
  [FraudDecision.internalRiskClaimHighRisk]: 'red',
  [FraudDecision.internalRiskMediumRisk]: '#ed941e',
}
